export function websiteProfilePath(
	slug: string,
	options?: { alreadyListed?: boolean },
): string {
	const path = `/website/${encodeURIComponent(slug)}`;
	return options?.alreadyListed ? `${path}?existing=1` : path;
}

/** Website profiles are served Astro-first, so leave the SPA for this hop. */
export function navigateToWebsiteProfile(
	slug: string,
	options?: { alreadyListed?: boolean },
): void {
	window.location.assign(websiteProfilePath(slug, options));
}
